import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import DividaService from '../../../../../services/divida-auth';
import { Link, useParams, Navigate } from 'react-router-dom';

const Divida = () => {
    let { id } = useParams()

    const [nome, setNome] = useState("");
    const [valor, setValor] = useState("");
    const [cnpj, setCnpj] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);

    async function fetchDivida(id) {
        const response = await DividaService.dividaEdit(id);
        setNome(response.data["nome"]);
        setValor(response.data["valor"]);
        setCnpj(response.data["cnpj"]);
    }

    useEffect(() => {
        fetchDivida(id);
    }, [id]);

    const ponto = (campo) => {
        return campo.replace(/,/g, ".");
    }


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const divida = await DividaService.editar(id, {
                nome: nome,
                valor: valor,
                cnpj: cnpj,
            })
            if (divida.data["_id"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }


    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={2}>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="nome">
                                <FloatingLabel
                                    label="Empresa/Pessoa"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="nome"
                                        value={nome}
                                        onChange={e => setNome(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="Valor devido">
                                <FloatingLabel
                                    label="Valor Devido"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="valor"
                                        value={valor}
                                        onChange={e => setValor(ponto(e.target.value))} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="cnpj">
                                <FloatingLabel
                                    label="CNPJ/CPF"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="cnpj"
                                        value={cnpj}
                                        onChange={e => setCnpj(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Salvar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/divida/listar'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Dívida ativa editada com sucesso!</Alert>
                <Navigate to={'/restrito/divida/listar'} />
            </Fragment>
        )
    }
}

export default Divida;